import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { ProcedureType } from '../../models/procedure-type';
import { storeByIMPSId } from '../../utils/converter';
import { getProcedureTypes } from '../../apis/emr-data';

export interface State {
    allIds: number[];
    byId: Dictionary<ProcedureType>;
    loading: Dictionary<boolean>;
}

export const procedureTypes = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: ProcedureType[],
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                const byId = {
                    ...state.byId,
                    ...storeByIMPSId(data)
                };
                return {
                    ...state,
                    allIds: Object.keys(byId).map(x => +x),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getProcedureTypesAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (selectors.getProcedureTypeIds(rootState.procedureTypes).length === 0) {
                try {
                    const data = await getProcedureTypes();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
